import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import MappingModal from "./Modals/MappingModal";
import ConnectionModal from "./Modals/ConnectionModal";
import ApiIntegrationModal from "./Modals/ApiIntegrationModal";
import { getAccounts } from "../../../services/api/integrations.api";
import { getSynchronizedAccount } from "../../../services/api/linkedin.api";
import AuthServ from "../../Auth/AuthServ/AuthServ";
import {
  CLIENT_ID_HUBSPOT,
  CLIENT_ID_SALESFORCE,
  CLIENT_ID_GMAIL,
  CLIENT_ID_AIRCALL,
} from "../../../constants";
import { ModalMessage, Permissions } from "../../../components";
import { FormattedMessage } from "react-intl";
import { usePermissions } from "../../../components/Permissions/permissions.hooks";

function IntegrationHeader() {
  return (
    <div className="integartion-header-ui">
      <div className="top-ui">
        <div className="left-ui">
          <label className="inner-title">
            <FormattedMessage id={"settings.integration.integrations"} />
          </label>
        </div>
      </div>
      <div className="content-ui">
        <p>
          <FormattedMessage id={"settings.integration.integrateYourFavorite"} />
        </p>
      </div>
    </div>
  );
}

function IntegrationCard({
  category,
  name,
  imagesrc,
  account,
  text,
  disabled,
  moreInfoLink,
  setAccount,
  apiKeyLink,
  handleShowApiIntegration,
  handleConnectionModal,
  handleMappingModal,
  selectedIntegration,
  setSelectedIntegration,
  isLoading,
  checkMemberPermissions,
}) {
  const handleConnectLinkedin = (e) => {
    if (e) e.stopPropagation();
    window.open("https://www.linkedin.com/feed/?synchro=true");
  };

  const selectIntegration = () => {
    if (!disabled)
      setSelectedIntegration({
        integration: name,
        category,
        imagesrc,
        account,
        text,
        disabled,
        moreInfoLink,
        apiKeyLink,
      });
  };

  const AuthConnect = () => {
    const oauthVariables = {
      clientId: {
        hubspot: CLIENT_ID_HUBSPOT,
        salesforce: CLIENT_ID_SALESFORCE,
        gmail: CLIENT_ID_GMAIL,
        aircall: CLIENT_ID_AIRCALL,
      },
      scopes: {
        hubspot: [
          "oauth",
          "crm.objects.contacts.read",
          "crm.objects.contacts.write",
          "crm.schemas.contacts.read",
          "crm.objects.owners.read",
          "crm.schemas.companies.read",
          "crm.schemas.deals.read",
        ],
        salesforce: [],
        gmail: [
          "profile",
          "email",
          "https://www.googleapis.com/auth/gmail.metadata",
          "https://www.googleapis.com/auth/gmail.send\t",
        ],
        aircall: ["public_api"],
      },
      oauthUrl: {
        hubspot: "https://app.hubspot.com/oauth/authorize",
        salesforce: "https://login.salesforce.com/services/oauth2/authorize",
        gmail: "https://accounts.google.com/o/oauth2/auth",
        aircall: "https://dashboard.aircall.io/oauth/authorize",
      },
    };
    if (name === "zapier") return <div />;
    return ["hubspot", "salesforce", "gmail"].indexOf(name) > -1 ? (
      <AuthServ
        clientId={oauthVariables.clientId[name]}
        scopes={oauthVariables.scopes[name]}
        oauthUrl={oauthVariables.oauthUrl[name]}
        type={name}
        responseType={"code"}
        redirectUri={window.location.origin + `/socialAuth/${name}/`}
        onLogin={setAccount}
        dim={{ height: 700, width: 800 }}
        inModal={false}
      />
    ) : !checkMemberPermissions("Sync") ? (
      <Permissions.CallToAction
        withoutIcon={true}
        toolTipStyle={{ width: 200 }}
      >
        <button className="connect-btn">
          <FormattedMessage id={"settings.profile.connect"} />
        </button>
      </Permissions.CallToAction>
    ) : (
      <button
        className="connect-btn"
        onClick={(e) => {
          selectIntegration();
          handleShowApiIntegration(e);
        }}
      >
        <FormattedMessage id={"settings.profile.connect"} />
      </button>
    );
  };

  return (
    <Col sm={6} md={6} lg={4}>
      <div
        className={"integrations-card " + (disabled ? "disabled-card" : "")}
        onClick={(e) => {
          if (!disabled) {
            selectIntegration();
            handleConnectionModal(e);
          }
        }}
      >
        {name === "linkedin" && (
          <span className="custom-tag-ui">
            {" "}
            <FormattedMessage id={"tags.recommended"} />{" "}
          </span>
        )}
        <div className="top-block">
          <div className="left-ui">
            <label>{category}</label>
            <p className="title username">{name}</p>
          </div>
          <div className="right-ui">
            <figure>
              <img src={imagesrc} alt="" />
            </figure>
          </div>
        </div>
        <div className="middle-content-ui">
          <p>{text}</p>
        </div>
        {!disabled && name !== "linkedin" && (
          <div className="bottom-ui">
            {account ? (
              <div className="connect-btn active">{account}</div>
            ) : !checkMemberPermissions("Sync") ? (
              <Permissions.CallToAction
                withoutIcon={true}
                toolTipStyle={{ width: 200 }}
              >
                <AuthConnect />
              </Permissions.CallToAction>
            ) : (
              <AuthConnect />
            )}
            {account && ["zapier", "gmail"].indexOf(name) === -1 ? (
              <button
                className="more-info-ui"
                onClick={(e) => {
                  selectIntegration();
                  handleMappingModal(e);
                }}
              >
                {isLoading &&
                selectedIntegration &&
                selectedIntegration.integration === name ? (
                  <img
                    src={"/assets/images/loading.gif"}
                    alt={"loading"}
                    style={{ height: "20px" }}
                  />
                ) : (
                  <FormattedMessage id={"mapping"} />
                )}
              </button>
            ) : (
              <button className="more-info-ui">
                {" "}
                <FormattedMessage id={"info.moreInfo"} />
              </button>
            )}
          </div>
        )}
        {name === "linkedin" && (
          <div>
            {account ? (
              <div className="middle-content-ui">
                <p>{"Linkedin account: " + account}</p>
              </div>
            ) : (
              <div className="bottom-ui">
                <button
                  className="connect-btn"
                  onClick={!disabled && handleConnectLinkedin}
                >
                  <FormattedMessage id={"settings.profile.connect"} />
                </button>
                <button className="more-info-ui">
                  {" "}
                  <FormattedMessage id={"info.moreInfo"} />
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </Col>
  );
}

function AvailableIntegrations({ profile }) {
  const [accounts, setAccounts] = useState({
    hubspot: null,
    salesforce: null,
    sendinblue: null,
    lemlist: null,
    pipedrive: null,
    zapier: null,
    linkedin: null,
    aircall: null,
  });
  const [selectedIntegration, setSelectedIntegration] = useState({
    integration: "",
    category: "",
    imagesrc: "",
    show: "",
    onHide: "",
    account: "",
    moreInfoLink: "",
    confirmConnect: "",
    disconnectAccount: "",
  });
  const [connectionError, setConnectionError] = useState(false);
  const [connectionErrorMessage, setConnectionErrorMessage] = useState(null);
  const [showMappingModal, setMappingModal] = useState(false);
  const [showApiIntegration, setShowApiIntegration] = useState(false);
  const [showConnectionModal, setConnectionModal] = useState(false);
  const [isConnectionModalOpen, setIsConnectionModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [checkPlanPermissions, checkMemberPermissions] = usePermissions(
    null,
    profile && profile.permissions,
    "Integration"
  );

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    let { data } = await getAccounts();
    let acc = data.accounts;
    let {
      data: { session },
    } = await getSynchronizedAccount();
    if (session) acc.linkedin = { linkedinEmail: session.id };
    setAccounts(acc);
  };

  const handleShowApiIntegration = (e) => {
    if (e) e.stopPropagation();
    setShowApiIntegration(!showApiIntegration);
  };

  const handleMappingModal = (e) => {
    if (e) e.stopPropagation();
    setMappingModal(!showMappingModal);
  };

  const handleConnectionModal = (e) => {
    if (e) e.stopPropagation();
    setIsConnectionModalOpen(!isConnectionModalOpen);
    setConnectionModal(!showConnectionModal);
  };

  const handleConnectionErrorModal = (e) => {
    if (e) e.stopPropagation();
    setConnectionError(!connectionError);
    if (isConnectionModalOpen) handleConnectionModal();
  };

  const confirmConnect = (integration, newAccount, err) => {
    if (!newAccount || newAccount === "null" || newAccount === "undefined") {
      if (err === "null" || err === "undefined") err = null;
      setConnectionErrorMessage(err);
      handleConnectionErrorModal();
      return;
    }
    let updatedAccounts = accounts;
    let updatedIntegration = {};
    updatedIntegration[integration + "Email"] = newAccount;
    updatedAccounts[integration] = updatedIntegration;
    setAccounts(updatedAccounts);
    setConnectionModal(false);
    handleMappingModal();
  };

  const confirmDisconnect = (integration) => {
    let updatedAccounts = accounts;
    let updatedIntegration = {};
    updatedIntegration[integration + "Email"] = false;
    updatedAccounts[integration] = updatedIntegration;
    setAccounts(updatedAccounts);
  };

  return (
    <div className="integrations-tool-wrapper available-tool">
      <div className="header-block">
        <p>
          <FormattedMessage id={"settings.integration.available"} />
        </p>
      </div>
      <div className="row content-listing">
        <IntegrationCard
          category={"NETWORKING"}
          name={"linkedin"}
          text={<FormattedMessage id={"settings.integration.linkedinText"} />}
          imagesrc={"/assets/images/linkedin.png"}
          account={
            accounts && accounts.linkedin && accounts.linkedin.linkedinEmail
          }
          moreInfoLink={"https://www.linkedin.com/"}
          disconnectAccount={() => confirmDisconnect("linkedin")}
          handleConnectionModal={handleConnectionModal}
          handleMappingModal={handleMappingModal}
          selectedIntegration={selectedIntegration}
          setSelectedIntegration={setSelectedIntegration}
          isLoading={isLoading}
        />
        <IntegrationCard
          category={"CRM"}
          name={"hubspot"}
          text={<FormattedMessage id={"settings.integration.hubspotText"} />}
          imagesrc={"/assets/images/hubspot.png"}
          account={
            accounts && accounts.hubspot && accounts.hubspot.hubspotEmail
          }
          setAccount={(newAccount, err) => {
            confirmConnect("hubspot", newAccount, err);
          }}
          moreInfoLink={"https://www.hubspot.com/"}
          disconnectAccount={() => confirmDisconnect("hubspot")}
          handleConnectionModal={handleConnectionModal}
          handleMappingModal={handleMappingModal}
          selectedIntegration={selectedIntegration}
          setSelectedIntegration={setSelectedIntegration}
          isLoading={isLoading}
          checkMemberPermissions={checkMemberPermissions}
        />
        {/*  <IntegrationCard
          category={"Email"}
          name={"gmail"}
          text={<FormattedMessage id={"settings.integration.gmailText"} />}
          imagesrc={"/assets/images//gmail.png"}
          account={accounts && accounts.gmail && accounts.gmail.gmailEmail}
          setAccount={(newAccount, err) => {
            confirmConnect("gmail", newAccount, err);
          }}
          moreInfoLink={"https://mail.google.com/"}
          disconnectAccount={() => confirmDisconnect("gmail")}
          handleConnectionModal={handleConnectionModal}
          handleMappingModal={handleMappingModal}
          selectedIntegration={selectedIntegration}
          setSelectedIntegration={setSelectedIntegration}
          isLoading={isLoading}
          checkMemberPermissions={checkMemberPermissions}
        />*/}
        <IntegrationCard
          category={"CRM"}
          name={"salesforce"}
          text={<FormattedMessage id={"settings.integration.salesforceText"} />}
          imagesrc={"/assets/images/salesforce.png"}
          account={
            accounts &&
            accounts.salesforce &&
            accounts.salesforce.salesforceEmail
          }
          setAccount={(newAccount, err) =>
            confirmConnect("salesforce", newAccount, err)
          }
          moreInfoLink={"https://www.salesforce.com/"}
          disconnectAccount={() => confirmDisconnect("salesforce")}
          handleConnectionModal={handleConnectionModal}
          handleMappingModal={handleMappingModal}
          selectedIntegration={selectedIntegration}
          setSelectedIntegration={setSelectedIntegration}
          isLoading={isLoading}
          checkMemberPermissions={checkMemberPermissions}
        />
        <IntegrationCard
          category={"Email Newsletters"}
          name={"sendinblue"}
          text={<FormattedMessage id={"settings.integration.sendinblueText"} />}
          imagesrc={"/assets/images/sendinblue.svg"}
          account={
            accounts &&
            accounts.sendinblue &&
            accounts.sendinblue.sendinblueEmail
          }
          setAccount={(newAccount, err) =>
            confirmConnect("sendinblue", newAccount, err)
          }
          moreInfoLink={"https://www.sendinblue.com/"}
          disconnectAccount={() => confirmDisconnect("sendinblue")}
          apiKeyLink={"https://account.sendinblue.com/advanced/api"}
          handleConnectionModal={handleConnectionModal}
          handleMappingModal={handleMappingModal}
          handleShowApiIntegration={handleShowApiIntegration}
          selectedIntegration={selectedIntegration}
          setSelectedIntegration={setSelectedIntegration}
          isLoading={isLoading}
          checkMemberPermissions={checkMemberPermissions}
        />
        <IntegrationCard
          category={"CRM"}
          name={"pipedrive"}
          text={<FormattedMessage id={"settings.integration.pipedriveText"} />}
          imagesrc={"/assets/images//pipedrive.png"}
          account={
            accounts && accounts.pipedrive && accounts.pipedrive.pipedriveEmail
          }
          setAccount={(newAccount, err) =>
            confirmConnect("pipedrive", newAccount, err)
          }
          moreInfoLink={"https://www.pipedrive.com/"}
          disconnectAccount={() => confirmDisconnect("pipedrive")}
          apiKeyLink={"https://app.pipedrive.com/settings/api"}
          handleConnectionModal={handleConnectionModal}
          handleMappingModal={handleMappingModal}
          handleShowApiIntegration={handleShowApiIntegration}
          selectedIntegration={selectedIntegration}
          setSelectedIntegration={setSelectedIntegration}
          isLoading={isLoading}
          checkMemberPermissions={checkMemberPermissions}
        />
        <IntegrationCard
          category={"Newsletters"}
          name={"lemlist"}
          text={<FormattedMessage id={"settings.integration.lemlistText"} />}
          imagesrc={"/assets/images/lemlist.png"}
          account={
            accounts && accounts.lemlist && accounts.lemlist.lemlistEmail
          }
          setAccount={(newAccount, err) =>
            confirmConnect("lemlist", newAccount, err)
          }
          moreInfoLink={"https://www.lemlist.com/"}
          disconnectAccount={() => confirmDisconnect("lemlist")}
          apiKeyLink={"https://app.lemlist.com/settings/integrations"}
          handleConnectionModal={handleConnectionModal}
          handleMappingModal={handleMappingModal}
          handleShowApiIntegration={handleShowApiIntegration}
          selectedIntegration={selectedIntegration}
          setSelectedIntegration={setSelectedIntegration}
          isLoading={isLoading}
          checkMemberPermissions={checkMemberPermissions}
        />
        <IntegrationCard
          category={"Integration"}
          name={"zapier"}
          text={<FormattedMessage id={"settings.integration.zapierText"} />}
          imagesrc={"/assets/images//zapier.png"}
          account={accounts && accounts.zapier && accounts.zapier.zapierEmail}
          moreInfoLink={"https://zapier.com/"}
          disconnectAccount={() => {}}
          handleConnectionModal={handleConnectionModal}
          handleMappingModal={() => {}}
          handleShowApiIntegration={() => {}}
          selectedIntegration={selectedIntegration}
          setSelectedIntegration={setSelectedIntegration}
          isLoading={isLoading}
          checkMemberPermissions={checkMemberPermissions}
        />
        <div>
          {showConnectionModal && (
            <ConnectionModal
              integration={selectedIntegration.integration}
              category={selectedIntegration.category}
              imagesrc={selectedIntegration.imagesrc}
              show={handleConnectionModal}
              onHide={handleConnectionModal}
              account={selectedIntegration.account}
              disconnectAccount={() =>
                confirmDisconnect(selectedIntegration.integration)
              }
              handleShowApiIntegration={handleShowApiIntegration}
              handleMappingModal={handleMappingModal}
              moreInfoLink={selectedIntegration.moreInfoLink}
              confirmConnect={(newAccount, err) =>
                confirmConnect(selectedIntegration.integration, newAccount, err)
              }
              checkMemberPermissions={checkMemberPermissions}
            />
          )}
          <ModalMessage
            toggle={connectionError}
            setToggle={handleConnectionErrorModal}
            title={<FormattedMessage id={"connectionFailed"} />}
            textElement={
              <>
                {connectionErrorMessage || (
                  <FormattedMessage
                    id={"settings.integration.anErrorHasOccurred"}
                  />
                )}
                {connectionErrorMessage ===
                  "The REST API permission is disabled on your Salesforce account" && (
                  <a target="_blank" href="https://help.salesforce.com/home">
                    <FormattedMessage
                      id={"settings.integration.clickHereToContact"}
                    />
                  </a>
                )}
              </>
            }
            action={"OK"}
            handleAction={handleConnectionErrorModal}
            forbidCancel={true}
          />
          {accounts &&
            accounts[selectedIntegration.integration] &&
            accounts[selectedIntegration.integration][
              selectedIntegration.integration + "Email"
            ] &&
            ["zapier", "linkedin", "gmail"].indexOf(
              selectedIntegration.integration
            ) === -1 && (
              <MappingModal
                integration={selectedIntegration.integration}
                category={selectedIntegration.category}
                imagesrc={selectedIntegration.imagesrc}
                show={showMappingModal}
                onHide={handleMappingModal}
                account={selectedIntegration.account}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
              />
            )}
          {["hubspot", "salesforce"].indexOf(selectedIntegration.integration) >
            -1 && showApiIntegration ? (
            <div />
          ) : (
            <ApiIntegrationModal
              integration={selectedIntegration.integration}
              imagesrc={selectedIntegration.imagesrc}
              show={showApiIntegration}
              onHide={handleShowApiIntegration}
              handleMappingModal={handleMappingModal}
              confirmConnect={(newAccount, err) =>
                confirmConnect(selectedIntegration.integration, newAccount, err)
              }
              apiKeyLink={selectedIntegration.apiKeyLink}
            />
          )}
        </div>
      </div>
    </div>
  );
}

function UpcomingIntegrations() {
  return (
    <div className="integrations-tool-wrapper">
      <div className="header-block">
        <p>
          <FormattedMessage id={"settings.integration.upcomingIntegrations"} />
        </p>
      </div>
      <div className="row content-listing">
        <IntegrationCard
          category={"SALES"}
          name={"Reply"}
          imagesrc={"/assets/images/reply.png"}
          text={<FormattedMessage id={"settings.integration.replyText"} />}
          disabled
        />
        <IntegrationCard
          category={"EMAIL AUTOMATION"}
          name={"ActiveCampaign"}
          imagesrc={"/assets/images/activecampaign.png"}
          text={
            <FormattedMessage id={"settings.integration.activeCampaignText"} />
          }
          disabled
        />
        <IntegrationCard
          category={"LEAD MANAGEMENT"}
          name={"NoCrm"}
          imagesrc={"/assets/images/nocrm.png"}
          text={<FormattedMessage id={"settings.integration.noCrmText"} />}
          disabled
        />
        <IntegrationCard
          category={"CRM"}
          name={"Zoho CRM"}
          imagesrc={"/assets/images/zohocrm.png"}
          text={<FormattedMessage id={"settings.integration.zohoCrmText"} />}
          disabled
        />
        <IntegrationCard
          category={"CRM"}
          name={"Agile CRM"}
          imagesrc={"/assets/images/agilecrm.png"}
          text={<FormattedMessage id={"settings.integration.agileCrmText"} />}
          disabled
        />
      </div>
    </div>
  );
}

function Footer() {
  return (
    <div className="content-box-ui mt-20">
      <div className="content-header mob-full">
        <div className="title-ui text-left wp-60">
          <label>
            <FormattedMessage
              id={"settings.integration.needMoreIntegrations"}
            />
          </label>
          <p>
            <FormattedMessage
              id={"settings.integration.ifYouFeelThatAreAnyIntegrations"}
            />{" "}
          </p>
        </div>
        <div className="button-ui">
          <a
            target="_blank"
            href="https://docs.google.com/forms/d/e/1FAIpQLScoB4YOYGDBEPTjjEkGUokdKk8BiOR-42CtZrEG4MLj5y2bAw/viewform?usp=sf_link"
            className="btn2 blue-text"
          >
            <FormattedMessage
              id={"settings.integration.requestAnIntegration"}
            />
          </a>
        </div>
      </div>
    </div>
  );
}

export default function Integration({ goToIntegrations, profile }) {
  return (
    <div id="integration">
      <IntegrationHeader />
      <AvailableIntegrations profile={profile} />
      {/*<UpcomingIntegrations />*/}
      <Footer />
    </div>
  );
}
